var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7812 6.09375C18.625 6.46875 20 8.09375 20 10C20 12.2188 18.1875 14 16 14H4.5C2 14 0 12 0 9.5C0 7.5625 1.25 5.875 3 5.28125C3 5.1875 3 5.09375 3 5C3 2.25 5.21875 0 8 0C9.84375 0 11.4688 1.03125 12.3125 2.53125C12.7812 2.1875 13.375 2 14 2C15.6562 2 17 3.34375 17 5C17 5.40625 16.9062 5.75 16.7812 6.09375Z",
    fill: "#0C66E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherAlert);
export default __webpack_public_path__ + "static/media/weatherAlert.697c8c395aac1d8992d09f8daae47a29.svg";
export { ForwardRef as ReactComponent };